import { isProduction } from '.'
import axios from 'axios'

export const CODE_OK = 200

let CSRFToken = ''

export async function getCSRFToken() {
  if (!CSRFToken) {
    let value = ''
    if (isProduction) {
      value = document.getElementsByTagName('meta')['csrf-token'].content
    } else {
      const { data } = await axios.get('/api/main')
      value = data.match(/<meta name="csrf-token" content="(.*)">/)[1]
    }
    CSRFToken = {
      '_csrf-member': value
    }
  }
  console.log('CSRFToken', CSRFToken)

  return CSRFToken
}

export const prefix = isProduction ? '' : '/api'

// export const homeHostName = 'http://' + location.hostname.replace('member', 'www')
